module.exports = __webpack_public_path__ + "static/media/logo.349f1803.svg";